<mat-autocomplete autoActiveFirstOption>
  @for (offer of data; track trackByIndex($index)) {
    <mat-option [value]="offer.id" (onSelectionChange)="emitSelect($event, offer)">
      <div class="tiime-option offer-option">
        <span class="ellipsis">{{ offer.label }}</span>
        <div class="flex gap-5">
          @if (offer.tag) {
            <tiime-tag color="accent" [tag]="offer.tag" small></tiime-tag>
          }
          <app-favorite-icon-button
            [favorite]="favorites() | includes: offer.id"
            (addToFavorites)="addToFavs(offer)"
            (removeFromFavorites)="removeFromFavs(offer)"
          />
        </div>
      </div>
    </mat-option>
  }
</mat-autocomplete>
